import axios from '@axios'

/** 
* Índice
* {@link getBankAccounts} - Obtener cuentas bancarias
* {@link getBankAccount} - Obtener cuenta bancaria
* {@link addBankAccount} - Crear cuenta bancaria
* {@link deleteBankAccount} - Eliminar cuenta bancaria
* {@link updateBankAccount} - Actualizar cuenta bancaria
*/

    /**
     * Obtener todads las cuentas bancarias
     * @param {*} queryParams 
     * @returns evaluations 
     */
    export const getBankAccounts = function (queryParams) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/bank-accounts', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Obtener cuenta bancaria
     * @param {integer} id ID de la cuenta bancaria 
     * @returns serie
     */

    export const getBankAccount = function ( id ) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/bank-accounts/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Añadir cuenta bancaria
     * @param {*} data Datos del cliente 
     * @returns 
     */

    export const addBankAccount = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/bank-accounts`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Borrar cuenta bancaria
     * @param {integer} id ID de la cuenta bancaria a borrar
     * @returns 
     */

    export const deleteBankAccount = function ({ id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/bank-accounts/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Actualizar cuenta bancaria
     * @param {integer} id ID de la cuenta bancaria a actualizar 
     * @returns 
     */

    export const updateBankAccount = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/bank-accounts/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }










